import React from "react";
import deliveringTrusted from "../assets/delivering-trusted.webp";

function About() {
  return (
    <>
    <section id="about" className="py-5">
      <div className="container text-center">
          <h2 className="fw-bold mb-4">About Leocord</h2>
          <p className="text-muted">Leocord is a trusted pharmaceutical supplier committed to delivering high-quality medicines and healthcare products to hospitals, clinics, and healthcare institutions. Our goal is to support healthcare providers with reliable pharmaceutical supply solutions that ensure uninterrupted patient care and operational efficiency.</p>
          <p className="text-muted">With a strong focus on regulatory compliance, product quality, and distribution reliability, Leocord works closely with healthcare institutions to meet their pharmaceutical needs with professionalism and integrity.</p>
      </div>
    </section>
    
    <section style={{ background: "#F4F8FC" }} className="py-5 text-center">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">100+</h3>
              <p className="text-muted">Products</p>
            </div>

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">50+</h3>
              <p className="text-muted">Hospital Partners</p>
            </div>

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">25+</h3>
              <p className="text-muted">Therapeutic Segments</p>
            </div>

            <div className="col-md-3 col-6">
              <h3 className="fw-bold text-primary">10+</h3>
              <p className="text-muted">Years Experience</p>
            </div>
        </div>
      </div>
    </section>
    <section
      style={{
        background: "#3A9C5A",
        paddingTop: "60px",
        paddingBottom: "60px"
      }}
      className="text-white d-flex align-items-center"
    >
      <div className="container">
        <div className="row align-items-center">

          <div className="col-lg-7">
            <h1 className="display-6 fw-bold mb-4">
              Delivering Trusted Pharmaceutical Solutions
              for Institutional Healthcare
            </h1>

            <p className="lead mb-4">
              Leocord partners with hospitals and healthcare institutions
              to provide high-quality, regulatory-compliant medicines
              with dependable supply chain integrity.
            </p>

            <a href="/about" className="btn btn-light btn-lg px-4 mb-3">
              About us
            </a>
          </div>

          <div className="col-lg-5 text-center">
            <img
              src={deliveringTrusted}
              alt="Healthcare"
              className="img-fluid rounded shadow"
            />
          </div>

        </div>
      </div>
    </section>
    <section className="py-5">      
      <div className="container">
          <div className="row">
            <div className="col-md-4 col-12">
              <h2 className="fs-4">Our Pharmaceutical Products</h2>
              <p>Leocord supplies a comprehensive range of pharmaceutical products designed to meet the needs of hospitals and healthcare providers. Our product portfolio includes essential medicines sourced from trusted manufacturers and verified suppliers to ensure safety, quality, and compliance with healthcare standards.</p>
            </div>
            <div className="col-md-4 col-12">
              <h2 className="fs-4">Reliable Healthcare Supply Chain</h2>
              <p>Our pharmaceutical distribution network ensures efficient supply chain management and timely delivery of essential medicines. By partnering with reliable manufacturers and logistics providers, Leocord maintains a strong distribution system that supports healthcare institutions across regions.</p>
            </div>
            <div className="col-md-4 col-12">
              <h2 className="fs-4">Supporting Healthcare Institutions</h2>
              <p>Leocord is committed to strengthening healthcare infrastructure by providing dependable pharmaceutical solutions. Our goal is to help hospitals and clinics maintain consistent access to essential medicines while ensuring the highest standards of safety and quality.</p>
            </div>
          </div>
      </div>
    </section>
    </>
  );
}

export default About;